if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    $('.gallery-slider-center').slick({
        accessibility: true,
        fade:true,
        dots:false,
        arrows:true,
        speed:600 ,
        asNavFor:'.gallery-slider',
        responsive: [
            {
              breakpoint: 600,
              settings: {
                arrows: true
              }
            },
        ]
    });

    $('.gallery-slider-sides').slick({
        accessibility: true,
        fade:true,
        dots:false,
        arrows:false,
        speed:600 ,
        asNavFor:'.gallery-slider'
    });
    $('.sym-hero-home').slick({
        accessibility: true,
        arrows:true,
        fade:true,
        speed:500 ,
        autoplay:true,
        autoplaySpeed:9000,
        asNavFor:'.sym-hero',
        responsive: [
            {
              breakpoint: 800,
              settings: {
                arrows:false,
                autoplay:true,
                autoplaySpeed:9000
              }
            },
        ]
    });
    $('.sym-second-hero-home').slick({
        accessibility: true,
        arrows:false,
        fade:true,
        speed:500 ,
        asNavFor:'.sym-hero',
        responsive: [
            {
              breakpoint: 700,
              settings: {
                arrows:false,
                autoplay:true,
                autoplaySpeed:9000
              }
            },
        ]
    });

    $('.reviews-slider').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
            }
          }
        ]
      });

    $('.gallery-block-entry__list').slick({
      slidesToShow: 3,
      arrows: false,
      autoplay: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            centerMode: true,
          }
        },
      ]
    })

    let form_id_2584 = document.querySelector( "#form_id-4125" );

    if(form_id_2584){
		
      let policyRemoveRequired = document.querySelector('[name="i_agree"]');
      let policyRemoveRequiredOffer = document.querySelector('[name="subscribe"]');
      let form_id_4125_yes_signup_formemail_signup = document.querySelector( '#form_id-4125-yes-signup-formemail-signup' );

      form_id_4125_yes_signup_formemail_signup.setAttribute( "checked", "checked" )
      form_id_4125_yes_signup_formemail_signup.checked = true

      let parent = policyRemoveRequired.parentElement;
      let parentOffer = policyRemoveRequiredOffer.parentElement;
  
      parent.classList.add('hidden');
      parentOffer.classList.add('hidden');
      policyRemoveRequired.classList.remove('required');
    }

    let activeButton= document.querySelector( "#id_0_4125" );
    let openButton= document.querySelector( ".banner-booking" );
    
    activeButton.addEventListener("click", () => {
      openButton.classList.toggle("open-banner");
    })


    document.addEventListener('DOMContentLoaded', function () {
      if( document.querySelector('.custom-offer-popup') ) {
        let custom_popup = document.querySelector('.custom-offer-popup');
        let closer = custom_popup.querySelector('.closer');

        if(closer) {
          closer.addEventListener('click', () => {
            custom_popup.classList.add('hidden')
          })
        }

        setTimeout(() =>{
          custom_popup.classList.remove('hidden')
        }, 3000)

        document.addEventListener('click', function (e) {
          const isClickInside = custom_popup.contains(e.target);
          if (!isClickInside && !custom_popup.classList.contains('hidden')) {
            custom_popup.classList.add('hidden');
          }
        });

      }
    });

})();

function copyText(){
  const texto = 'DIRECT';



  const textarea = document.createElement('textarea');
  textarea.value = texto;

  document.body.appendChild(textarea);

  textarea.select();
  textarea.setSelectionRange(0, 99999); 

  document.execCommand('copy');


  document.body.removeChild(textarea);


}


function addCustomListener(){
  let openButtonTwo= document.querySelector( ".step-two__text" );
  let openButton= document.querySelector( ".banner-booking" );
  openButtonTwo.addEventListener("click", () => {
    openButton.classList.toggle("open-banner");
    console.log("test");     
  })
}